import { ENDPOINTS } from 'config/endpoints';
import {
  PatchScoringSettings,
  ScoreSettingsTypes,
} from 'crono-fe-common/types/DTO/patchScoringSettings';
import CronoError from 'crono-fe-common/types/error';
import { Request } from 'crono-fe-common/types/request';
import { Response } from 'crono-fe-common/types/response';
import { useQuery } from '@tanstack/react-query';
import client from 'utils/clients/client';

export const useGetScoreSettings = (
  type: ScoreSettingsTypes,
  enabled = true,
) => {
  return useQuery<Response<PatchScoringSettings>, CronoError>({
    queryKey: [ENDPOINTS.scoreSettings.main, type],
    queryFn: () => {
      const request: Request = {
        url: `${ENDPOINTS.scoreSettings.main}?type=${type}`,
        config: {
          method: 'get',
        },
      };
      return client(request);
    },
    enabled: Boolean(type) && enabled,
    staleTime: 60 * 60 * 1000,
  });
};
